import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-[var(--font-heading)] mb-3">
            内容分类导览
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            禁漫天堂提供丰富的漫画内容分类，涵盖多种风格与题材，满足不同读者的需求。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 flex items-start gap-4"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {cat.articleCount} 部作品
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}